import { TextField as TextFieldUI } from "@mindlercare/ui-web";
import { useDemo } from "contexts/DemoContext";
import { withTranslation } from "react-i18next";
import { ComponentProps } from "react";

type Props = Omit<ComponentProps<typeof TextFieldUI>, "hideSensitiveData">;

const TranslatedTextField = withTranslation()(TextFieldUI);

export const TextField = (props: Props) => {
  const hideSensitiveData = useDemo();
  return (
    <TranslatedTextField {...props} hideSensitiveData={hideSensitiveData} />
  );
};
